<div class="pswp-gallery" id="gallery" [style.max-width]="maxWidth">
  @for (image of images; track image; let i = $index) {
    <a [href]="image.href" [attr.data-pswp-width]="image.width" [attr.data-pswp-height]="image.height" target="_blank" [style.display]="image.thumbnailUrl && i < (maxThumbs ?? Infinity) ? null : 'none'" [attr.aria-label]="image.alt">
      @if (image.thumbnailUrl && i < (maxThumbs ?? Infinity)) {
        <img [src]="image.thumbnailUrl" [alt]="image.alt" [width]="image.thumbnailWidth" [height]="image.thumbnailHeight" />
      }
    </a>
  }
  @if (hiddenImageCount > 0) {
    <div class="more-images">+{{ hiddenImageCount }} more</div>
  }
</div>
